import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {environment} from '../../../environments/environment';

export const canActivateAiTemplateAnswering: CanActivateFn = () =>
  environment.aiTemplateAnsweringEnabled || inject(Router).parseUrl('/provider/templates');
